import React from "react";

const RunAsContext = React.createContext<{ runAsUserId: string | undefined; setRunAsUserId: (userId: string | undefined) => void }>({
  runAsUserId: undefined,
  setRunAsUserId: (userId: string | undefined) => {},
});
export const Consumer = RunAsContext.Consumer;

export default RunAsContext;
